"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionCode = exports.AccessGroup = exports.AccessType = exports.AccessReq = exports.AccessMap = exports.Access = void 0;
var Access;
(function (Access) {
    Access["PUBLIC"] = "PUBLIC";
    Access["VIEW_ALL"] = "VIEW_ALL";
    Access["VIEW_ON_QUOTATION"] = "VIEW_ON_QUOTATION";
})(Access = exports.Access || (exports.Access = {}));
exports.AccessMap = {
    VIEW_ON_QUOTATION: {
        id: 'VIEW_ON_QUOTATION',
        label: 'Seller hidden until quotation has been created',
    },
    VIEW_ALL: {
        id: 'VIEW_ALL',
        label: 'Seller visible',
    },
};
class AccessReq {
}
exports.AccessReq = AccessReq;
var AccessType;
(function (AccessType) {
    AccessType["PUBLIC"] = "PUBLIC";
    AccessType["WHITE_LIST"] = "WHITE_LIST";
    AccessType["BLACK_LIST"] = "BLACK_LIST";
})(AccessType = exports.AccessType || (exports.AccessType = {}));
class AccessGroup {
    static withId(id) {
        const o = new AccessGroup();
        o.groupId = id;
        return o;
    }
    static transform(accessGroup) {
        if (accessGroup) {
            accessGroup.whiteList = accessGroup.access === AccessType.WHITE_LIST ? accessGroup.groupId : undefined;
            accessGroup.blackList = accessGroup.access === AccessType.BLACK_LIST ? accessGroup.groupId : undefined;
        }
        return accessGroup;
    }
}
exports.AccessGroup = AccessGroup;
class RegionCode {
}
exports.RegionCode = RegionCode;
